import { Base } from "../Base";
export class Class extends Base {
    name;
    is;
    prune;
    class = "from";
    constructor(name, is, prune = (value) => super.prune(value)) {
        super();
        this.name = name;
        this.is = is;
        this.prune = prune;
    }
    static create(name, is, prune) {
        return new Class(name, is, prune);
    }
}
//# sourceMappingURL=Class.js.map